<div class="box-theme">
  <div class="head">
    <div class="header">
      <div class="ico">
        <img src="./assets/img/icono-contactanos.png" alt="Contáctenos">
      </div>
    </div>
    <div class="body">
      <h1>Contáctanos</h1>
      <p>En esta sección podrás ponerte en contacto con nosotros.<br/></p>
    </div>
  </div>
  <div class="body">
    <!-- Indicador de pasos -->
    <div class="counter-pasos">
      <ul class="stepper-lineas">
        <li>
          <span class="linea-current"></span>
        </li>
        <li></li>
      </ul>
      <ul class="stepper">
        <li [ngClass]="{ 'numActive': pasos[0].P1.CurrentNum }">
          <p>1</p>
        </li>
        <li [ngClass]="{ 'numActive': pasos[0].P2.CurrentNum }">
          <p>2</p>
        </li>
        <li [ngClass]="{ 'numActive': pasos[0].P3.CurrentNum }">
          <p>3</p>
        </li>
      </ul>
    </div>

    <!-- PASO NUMERO 1 -->
    <div class="paso-1" *ngIf="pasos[0].P1.I">
      <div class="header">
        <h2>Para gestionar este trámite primero debes reunir<br/> los siguientes documentos:</h2>
      </div>
      <div class="body">
        <ul>
          <li>
            <p class="numero">1</p>
            <p class="titulo">Documento que respalde el tipo de solicitud que tengas.</p>
          </li>
        </ul>
      </div>
      <div class="footer">
        <div class="callToAcction">
          <div class="mitad">
            <input type="button" value="VOLVER" class="btn btn-volver" [routerLink]="['/home']">
          </div>
          <div class="mitad text-right">
            <div class="info-continuar text-center">
              <p>Si ya tienes los documentos,<br/>presiona continuar</p>
              <input type="button" value="CONTINUAR" class="btn btn-continuar" (click)="gotoPaso(2, null)">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- PASO NUMERO 2 -->
    <div class="paso-2" *ngIf="pasos[0].P2.I">
      <div class="header">
        <h2>En esta sección puedes escribirnos para alguna solicitud o petición que tengas.</h2>
      </div>
      <div class="body">
        <form [formGroup]="formData">
          <div class="form">
            <div class="head">
              <h2>Identificación del solicitante</h2>
              <p class="txt-orange">(**Datos obligatorios)</p>
            </div>
            <div class="body">
              <ul>
                <li>
                  <div class="box-campo-form">
                    <div class="cont-numero-cliente">
                      <input type="text"
                             id="nCliente"
                             placeholder="**Número de cliente"
                             [maxLength]="9"
                             formControlName="nCliente"
                             pattern="[0-9]*"
                             (input)="allowOnlyNumbers($event)"
                             [ngClass]="{'is-invalid': f.nCliente.errors && (f.nCliente.dirty || f.nCliente.touched)}"/>
                      <div class="error" *ngIf="f.nCliente.errors && (f.nCliente.dirty || f.nCliente.touched)">
                        <p *ngIf="f.nCliente.errors?.required">
                          Dato obligatorio
                        </p>
                        <p *ngIf="f.nCliente.errors?.pattern || f.nCliente.errors?.numClienteValid">
                          Número de cliente inválido
                        </p>
                      </div>
                      <div class="div-numero-cliente">
                        <a style="cursor: pointer;" (click)="mostrarNumeroCliente()">
                          <img class="info-numero-cliente" src="./assets/img/info-icon.png" alt="Información número de cliente">
                        </a>
                      </div>
                    </div>
                  </div>
                </li>

                <li>
                  <div class="box-campo-form">
                    <input type="text"
                           placeholder="**Nombre y apellido"
                           formControlName="nombre"
                           [maxLength]="200"
                           [ngClass]="{'is-invalid': f.nombre.errors && (f.nombre.dirty || f.nombre.touched)}"/>
                    <div class="error" *ngIf="f.nombre.errors && (f.nombre.dirty || f.nombre.touched)">
                      <p *ngIf="f.nombre.errors?.required">
                        Dato obligatorio
                      </p>
                      <p *ngIf="f.nombre.errors?.pattern">
                        Nombre inválido
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <input type="text"
                           placeholder="**Teléfono de contacto"
                           formControlName="telefono"
                           [maxLength]="9"
                           [ngClass]="{'is-invalid': f.telefono.errors && (f.telefono.dirty || f.telefono.touched)}"/>
                    <div class="error" *ngIf="f.telefono.errors && (f.telefono.dirty || f.telefono.touched)">
                      <p *ngIf="f.telefono.errors?.required">
                        Dato obligatorio
                      </p>
                      <p *ngIf="f.telefono.errors?.pattern">
                        Teléfono inválido
                      </p>
                    </div>
                  </div>
                </li>

                <li>
                  <div class="box-campo-form">
                    <input type="email"
                           placeholder="**Correo electrónico"
                           formControlName="email"
                           [maxLength]="200"
                           [ngClass]="{'is-invalid': f.email.errors && (f.email.dirty || f.email.touched)}"/>
                    <div class="error" *ngIf="f.email.errors && (f.email.dirty || f.email.touched)">
                      <p *ngIf="f.email.errors?.required">
                        Dato obligatorio
                      </p>
                      <p *ngIf="f.email.errors?.email">
                        Email inválido
                      </p>
                    </div>
                  </div>
                </li>

                <li>
                  <div class="box-campo-form">
                    <input type="text"
                           placeholder="**Cédula de identidad"
                           formControlName="rut"
                           [maxLength]="12"
                           [ngClass]="{'is-invalid': f.rut.errors && (f.rut.dirty || f.rut.touched)}"
                           (blur)="formatearRut($event)"/>
                    <div class="error" *ngIf="f.rut.errors && (f.rut.dirty || f.rut.touched)">
                      <p *ngIf="f.rut.errors?.required" >
                        Dato obligatorio
                      </p>
                      <p *ngIf="f.rut.errors?.rutValid">
                        RUT inválido
                      </p>
                    </div>
                  </div>
                </li>

                <li class="seleccion-checkbox">
                  <ul>
                    <li>
                      <div class="box-campo-form">
                        <div class="box-radio">
                          <label class="container-radio">
                            <input type="radio"
                                   formControlName="tipoContacto"
                                   name="tipoContacto"
                                   value="consulta">
                            <span class="radiomark"></span>
                          </label>
                          <p>Consulta</p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="box-campo-form">
                        <div class="box-radio">
                          <label class="container-radio">
                            <input type="radio"
                                   formControlName="tipoContacto"
                                   name="tipoContacto"
                                   value="reclamo">
                            <span class="radiomark"></span>
                          </label>
                          <p>Reclamo</p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="box-campo-form">
                        <div class="box-radio">
                          <label class="container-radio">
                            <input type="radio"
                                   formControlName="tipoContacto"
                                   name="tipoContacto"
                                   value="sugerencia">
                            <span class="radiomark"></span>
                          </label>
                          <p>Sugerencia</p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="box-campo-form">
                        <div class="box-radio">
                          <label class="container-radio">
                            <input type="radio"
                                   formControlName="tipoContacto"
                                   name="tipoContacto"
                                   value="felicitacion">
                            <span class="radiomark"></span>
                          </label>
                          <p>Felicitación</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div class="error" *ngIf="f.tipoContacto.errors?.required && (f.tipoContacto.dirty || f.tipoContacto.touched)">
                    <p *ngIf="f.tipoContacto.errors?.required && (f.tipoContacto.dirty || f.tipoContacto.touched)" class="required-field">
                      Dato obligatorio
                    </p>
                  </div>
                </li>

               

                <li>
                  <div class="box-campo-form">
                    <ng-select
                      #tipoRegulador
                      [items]="dataProceso"
                      [selectOnTab]="true"
                      bindValue="id"
                      bindLabel="valor"
                      placeholder="**Elige un proceso relacionado"
                      id="proceso"
                      name="proceso"
                      formControlName="proceso"
                      [ngClass]="{'is-invalid': f.proceso.errors && (f.proceso.dirty || f.proceso.touched)}"
                      notFoundText="Proceso no encontrado"
                      (change)="onProcesoChange($event)">
                    </ng-select>
                    <div class="error" *ngIf="f.proceso.errors && (f.proceso.dirty || f.proceso.touched)">
                      <p *ngIf="f.proceso.errors?.required">
                        Dato obligatorio
                      </p>
                    </div>
                  </div>
                </li>
                <li *ngIf="procesoSeleccionado">
                  <div class="box-campo-form">
                    <ng-select
                      [items]="filteredDataSubProceso"
                      [selectOnTab]="true"
                      bindValue="id"
                      bindLabel="valor"
                      placeholder="**Elige un sub-proceso relacionado"
                      id="subproceso"
                      name="subproceso"
                      formControlName="subproceso"
                      [ngClass]="{'is-invalid': f.subproceso.errors && (f.subproceso.dirty || f.subproceso.touched)}"
                      notFoundText="Subproceso no encontrado">
                    </ng-select>
                    <div class="error" *ngIf="f.subproceso.errors && (f.subproceso.dirty || f.subproceso.touched)">
                      <p *ngIf="f.subproceso.errors?.required">
                        Dato obligatorio
                      </p>
                    </div>
                  </div>
                </li>

                <!-- Campo de medio de envío de respuesta -->
                <li *ngIf="f.tipoContacto.value === 'reclamo'">
                  <div class="box-campo-form">
                    <ng-select
                      [items]="dataMedioEnvio"
                      [selectOnTab]="true"
                      bindValue="id"
                      bindLabel="valor"
                      placeholder="**¿Cómo desea recibir nuestra respuesta?"
                      id="medioEnvioRespuesta"
                      name="medioEnvioRespuesta"
                      formControlName="medioEnvioRespuesta"
                      [ngClass]="{'is-invalid': f.medioEnvioRespuesta.errors && (f.medioEnvioRespuesta.dirty || f.medioEnvioRespuesta.touched)}"
                      notFoundText="Opción no encontrada"
                      (change)="onMedioEnvioChange($event)">
                    </ng-select>
                    <div class="error" *ngIf="f.medioEnvioRespuesta.errors && (f.medioEnvioRespuesta.dirty || f.medioEnvioRespuesta.touched)">
                      <p *ngIf="f.medioEnvioRespuesta.errors?.required">
                        Dato obligatorio
                      </p>
                    </div>
                  </div>
                </li>

                <!-- Campo consolidado para dirección postal -->
                <li *ngIf="mostrarDireccionPostal">
                  <div class="box-campo-form">
                    <input type="text"
                           placeholder="**Dirección, Número y Comuna"
                           formControlName="direccionPostal"
                           [maxLength]="300"
                           [ngClass]="{'is-invalid': f.direccionPostal.errors && (f.direccionPostal.dirty || f.direccionPostal.touched)}"/>
                    <div class="error" *ngIf="f.direccionPostal.errors && (f.direccionPostal.dirty || f.direccionPostal.touched)">
                      <p *ngIf="f.direccionPostal.errors?.required">
                        Dato obligatorio
                      </p>
                    </div>
                  </div>
                </li>

                <!-- Sección de Reclamo por Cobro - Se muestra al seleccionar Reclamo -->
                <li *ngIf="mostrarCheckboxReclamoCobro">
                  <div class="box-campo-form">
                    <div style="display: flex; align-items: center; gap: 20px; flex-wrap: wrap;">
                      <p style="font-weight: bold; margin: 0;">**Reclamo por cobro</p>
                      <div class="box-radio">
                        <label class="container-radio">
                          <input type="radio" formControlName="esReclamoPorCobro" name="esReclamoPorCobro" [value]="true">
                          <span class="radiomark"></span>
                        </label>
                        <p>Sí</p>
                      </div>
                      <div class="box-radio">
                        <label class="container-radio">
                          <input type="radio" formControlName="esReclamoPorCobro" name="esReclamoPorCobro" [value]="false">
                          <span class="radiomark"></span>
                        </label>
                        <p>No</p>
                      </div>
                    </div>
                    <div class="error" *ngIf="mostrarCheckboxReclamoCobro && f.esReclamoPorCobro.value === null && (f.esReclamoPorCobro.dirty || f.esReclamoPorCobro.touched)">
                      <p>Dato obligatorio</p>
                    </div>
                  </div>
                </li>

                <!-- Campos condicionales de Reclamo por Cobro -->
                <li *ngIf="esReclamoPorCobro">
                  <div class="box-campo-form">
                    <input type="text"
                           placeholder="**Monto reclamado (Ej: 25.000)"
                           formControlName="montoReclamado"
                           id="montoReclamado"
                           name="montoReclamado"
                           (input)="formatearMonto($event)"
                           (keypress)="allowOnlyNumbers($event)"
                           maxlength="20"
                           [ngClass]="{'is-invalid': f.montoReclamado.errors && (f.montoReclamado.dirty || f.montoReclamado.touched)}"/>
                    <div class="error" *ngIf="f.montoReclamado.errors && (f.montoReclamado.dirty || f.montoReclamado.touched)">
                      <p *ngIf="f.montoReclamado.errors?.required">
                        Dato obligatorio
                      </p>
                      <p *ngIf="f.montoReclamado.errors?.min">
                        El monto debe ser mayor a 0
                      </p>
                    </div>
                  </div>
                </li>

                <li *ngIf="esReclamoPorCobro">
                  <div class="box-campo-form">
                    <ng-select
                      [items]="dataConceptoCobro"
                      [selectOnTab]="true"
                      bindValue="id"
                      bindLabel="valor"
                      placeholder="**Seleccione el concepto de cobro reclamado"
                      id="conceptoCobro"
                      name="conceptoCobro"
                      formControlName="conceptoCobro"
                      [ngClass]="{'is-invalid': f.conceptoCobro.errors && (f.conceptoCobro.dirty || f.conceptoCobro.touched)}"
                      notFoundText="Concepto no encontrado"
                      (change)="onConceptoCobroChange($event)">
                    </ng-select>
                    <div class="error" *ngIf="f.conceptoCobro.errors && (f.conceptoCobro.dirty || f.conceptoCobro.touched)">
                      <p *ngIf="f.conceptoCobro.errors?.required">
                        Dato obligatorio
                      </p>
                    </div>
                  </div>
                </li>

                <li *ngIf="esReclamoPorCobro && mostrarOtroConcepto">
                  <div class="box-campo-form">
                    <input type="text"
                           placeholder="**Describa el concepto de cobro que reclama"
                           formControlName="otroConceptoCobro"
                           [maxLength]="200"
                           [ngClass]="{'is-invalid': f.otroConceptoCobro.errors && (f.otroConceptoCobro.dirty || f.otroConceptoCobro.touched)}"/>
                    <div class="error" *ngIf="f.otroConceptoCobro.errors && (f.otroConceptoCobro.dirty || f.otroConceptoCobro.touched)">
                      <p *ngIf="f.otroConceptoCobro.errors?.required">
                        Dato obligatorio
                      </p>
                    </div>
                  </div>
                </li>

                <li style="margin-top: 30px;">
                  <div class="box-campo-form">
                    <textarea
                      placeholder="**Detalla tu consulta"
                      formControlName="detalle"
                      [maxLength]="1400"
                      [ngClass]="{'is-invalid': f.detalle.errors && (f.detalle.dirty || f.detalle.touched)}">
                    </textarea>
                    <div class="error" *ngIf="f.detalle.errors && (f.detalle.dirty || f.detalle.touched)">
                      <p *ngIf="f.detalle.errors?.required">
                        Dato obligatorio
                      </p>
                      <p *ngIf="f.detalle.errors?.pattern">
                        Detalle contiene caracteres inválidos
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
              
              <!-- Aviso: Si menciona comprobantes en la descripción -->
              <div class="aviso-adjuntos" 
                   *ngIf="f.detalle.value && detectarMencionComprobantes(f.detalle.value) && cantidadAdjuntos === 0 && !avisoComprobantesDismissed"
                   style="background-color: #fff3cd; border: 2px solid #ff6600; border-radius: 8px; padding: 20px; margin: 20px 0; position: relative;">
                <button type="button"
                        (click)="dismissAvisoComprobantes()"
                        style="position: absolute; top: 8px; right: 10px; background: none; border: none; font-size: 1.3em; line-height: 1; cursor: pointer; color: #856404; padding: 0;"
                        title="Cerrar">&#x2715;</button>
                <div style="display: flex; align-items: flex-start;">
                  <div style="font-size: 2em; margin-right: 15px;">💡</div>
                  <div>
                    <h4 style="color: #ff6600; margin: 0 0 10px 0; font-size: 1.2em;">Sugerencia Importante</h4>                   
                    <p style="margin: 0 0 8px 0; font-size: 0.9em; color: #856404; text-align: left;">
                      Te recomendamos adjuntar los archivos correspondientes en la sección "Documentos adjuntos" para que queden registrados en la constancia de ingreso de tu solicitud.
                    </p>
                    <p style="margin: 0; font-size: 0.9em; color: #856404; text-align: left;">
                      Esto ayudará a agilizar la gestión de tu solicitud y tener un respaldo completo de tu caso.
                    </p>
                  </div>
                </div>
              </div>
              
              <ul>
              </ul>
            </div>
          </div>            
          <div class="form">
            <div class="head">
              <h2>Documentos adjuntos:</h2>
            </div>
            <p class="txt-tipo">
              (Se permiten los siguientes tipos de archivos: .PNG, .JPEG, .DOC, .DOCX, .PDF - Máximo 5MB por archivo)
            </p>
            <div class="body">
              <ul class="uploadFile">
                <li *ngFor="let doc of documentosAdjuntos; let i = index" class="documento-item">
                  <!-- Fila única: label | descripción | botón archivo | iconos -->
                  <div class="documento-row">
                    <div class="documento-label">
                      <span>Documento {{i + 1}}:</span>
                    </div>
                    <div class="documento-detalle">
                      <input type="text"
                             [(ngModel)]="doc.detalle"
                             [ngModelOptions]="{standalone: true}"
                             placeholder="Detalle del documento (Ej: Boleta reclamada)"
                             maxlength="100"
                             class="input-detalle"
                             [ngClass]="{'is-invalid': descripcionDuplicada(i)}">
                      <div class="error-duplicado" *ngIf="descripcionDuplicada(i)">
                        <p>⚠️ Esta descripción ya existe en otro documento.</p>
                      </div>
                    </div>
                    <div class="documento-archivo">
                      <div class="campo-archivo">
                        <label [for]="'fileDocumento' + i" class="custom-file-input"
                               [title]="doc.fileName || 'Seleccionar archivo'">
                          {{doc.fileName || 'Seleccionar archivo'}}
                        </label>
                        <input type="file"
                               class="custom-file-input hidden"
                               [name]="'fileDocumento' + i"
                               [id]="'fileDocumento' + i"
                               accept="{{mimeTypes}}"
                               (change)="fileDocContactolaProgress($event, i)">
                      </div>
                      <div class="acciones-archivo">
                        <img src="./assets/img/check-0.png" alt="Archivo no cargado" *ngIf="!doc.infoMessage && !doc.errorInfoMessage">
                        <img src="./assets/img/check-1.png" alt="Archivo cargado" *ngIf="doc.infoMessage">
                        <img src="./assets/img/error.png" alt="Error" *ngIf="doc.errorInfoMessage" [title]="doc.errorInfoMessage">
                        <img src="./assets/img/ver-0.png" alt="Ver archivo" *ngIf="!doc.infoMessage && !isMobile" class="disabled-icon" title="Ver archivo">
                        <img src="./assets/img/ver-1.png" alt="Ver archivo" *ngIf="doc.infoMessage && !isMobile" (click)="lightboxFile(i)" class="clickable-icon" title="Ver archivo">
                        <img src="./assets/img/delete-0.png" alt="Eliminar archivo" (click)="eliminarArchivo(i)" class="clickable-icon" title="Eliminar este archivo">
                        <img src="./assets/img/delete-1.png" alt="Eliminar línea" *ngIf="documentosAdjuntos.length > 1" (click)="eliminarLineaDocumento(i)" title="Eliminar esta línea" class="clickable-icon">
                      </div>
                    </div>
                  </div>
                  <!-- Fila de errores (file error) -->
                  <div class="documento-error-row" *ngIf="doc.errorInfoMessage">
                    <span class="error-message">{{doc.errorInfoMessage}}</span>
                  </div>
                </li>
              </ul>
              <div style="text-align: center; margin-top: 15px;">
                <button type="button" 
                        class="btn btn-agregar-linea" 
                        (click)="agregarLineaDocumento()"
                        [disabled]="documentosAdjuntos.length >= 8"
                        style="padding: 10px 20px; background-color: #ff6600; color: white; border: none; border-radius: 4px; cursor: pointer; font-weight: bold;"
                        [style.opacity]="documentosAdjuntos.length >= 8 ? '0.5' : '1'"
                        [style.cursor]="documentosAdjuntos.length >= 8 ? 'not-allowed' : 'pointer'">
                  + Agregar otro documento ({{documentosAdjuntos.length}}/8)
                </button>
              </div>
              <div>
                <p style="font-size: 0.9em; margin-top: 15px; text-align: center; color: black;">
                  Puede adjuntar hasta 8 documentos diferentes con su respectivo detalle.
                </p>
                <p style="font-size: 0.9em; margin-top: 5px; text-align: center; color: #ff6600; font-weight: bold;" *ngIf="cantidadAdjuntos > 0">
                  Archivos adjuntos cargados: {{cantidadAdjuntos}} de {{documentosAdjuntos.length}}
                </p>
              </div>
            </div>
              <div class="terminos-condiciones">
              <ul>
                <li>
                  <div class="box-campo-form">
                    <label class="container-checkbox">
                      <input type="checkbox"
                             formControlName="terminos"
                             name="terminos"
                             value="terminos"
                             [ngClass]="{'is-invalid': f.terminos.errors && (f.terminos.dirty || f.terminos.touched)}">
                      <span class="checkmark"></span>
                    </label>
                    <p>
                      <a style="cursor: pointer;" (click)="mostrarTerminos($event)">
                        He leído y aceptado la política de privacidad.
                      </a>
                      <span class="error" *ngIf="f.terminos.errors && (f.terminos.dirty || f.terminos.touched)">
                        <span *ngIf="f.terminos.errors?.required">
                          <br>Check requerido
                        </span>
                      </span>
                    </p>
                  </div>
                </li>

                <li>
                  <div class="box-campo-form">
                    <label class="container-checkbox">
                      <input [ngClass]="getCheckboxClass()"
                             type="checkbox"
                             formControlName="suscripcion"
                             name="suscripcion"
                             value="suscripcion"
                             (change)="onSuscripcionChange($event)">
                      <span class="checkmark"></span>
                    </label>
                    <p>
                      <a [ngClass]="getTextClass()"
                         style="cursor: pointer;"
                         (click)="mostrarSuscripcion($event)">
                        Suscripción a Boleta electrónica.
                      </a>
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            <!-- Panel Informativo Legal -->
            <div class="panel-legal-section mt-4 mb-5" style="padding: 20px; margin: 20px 0;">
              <div>
                <p><strong style="color: rgb(0, 69, 113); font-size: 1.3em;">INFORMACIÓN LEGAL - SUS DERECHOS</strong></p>
                
                <!-- Plazos de Respuesta -->
                <div class="row">    
                  <div class="icono">
                    <img alt="plazos" src="./assets/img/servicio-continuo.png">
                  </div>               
                  <div class="texto-legal">
                    <p>
                      <strong style="color: rgb(0, 69, 113);">• Plazos de Respuesta: </strong>
                      <strong>Consultas y Sugerencias:</strong> Metrogas responderá en un plazo máximo de 10 días hábiles desde la fecha de ingreso. 
                      <strong>Reclamos:</strong> La empresa tiene un plazo de 10 días hábiles para dar respuesta a su reclamo. 
                      La respuesta será enviada al medio de contacto que usted haya seleccionado (correo electrónico o dirección postal).
                    </p>
                  </div>
                </div>

                <!-- Intervención SEC -->
                <div class="row">
                  <div class="icono">
                    <img alt="sec" src="./assets/img/mas.png">
                  </div>
                  <div class="texto-legal">
                    <p>
                      <strong style="color: rgb(0, 69, 113);">• Superintendencia de Electricidad y Combustibles (SEC): </strong>
                      Si no recibe respuesta dentro de los plazos establecidos, o no está conforme con la respuesta recibida, usted puede solicitar la intervención de la SEC. 
                      Contacto SEC: Sitio web <a href="https://www.sec.cl" target="_blank" style="color: #ff6600;">www.sec.cl</a>, Teléfono 600 511 2222, o presencialmente en sus oficinas regionales. 
                      La SEC es el organismo fiscalizador que vela por el cumplimiento de la normativa vigente.
                    </p>
                  </div>
                </div>

                <!-- Medio de Contacto -->
                <div class="row">
                  <div class="icono">
                    <img alt="contacto" src="./assets/img/seguro.png">
                  </div>
                  <div class="texto-legal">
                    <p>
                      <strong style="color: rgb(0, 69, 113);">• Medio de Respuesta Elegido: </strong>
                      La respuesta a su solicitud será enviada exclusivamente al medio de contacto que usted seleccionó en este formulario. 
                      Es importante mantener actualizados sus datos de contacto para asegurar la recepción oportuna de nuestra respuesta.
                    </p>
                  </div>
                </div>

                <!-- Nota Legal -->
                <div class="row">
                  <div class="icono">
                    <img alt="legal" src="./assets/img/servicio-continuo.png">
                  </div>
                  <div class="texto-legal">
                    <p>
                      <strong style="color: rgb(0, 69, 113);">• Cumplimiento Normativo: </strong>
                      Este formulario cumple con lo establecido en el Decreto N°79, Artículo 156, que garantiza sus derechos como consumidor de servicios de gas. 
                      Toda la información proporcionada será tratada conforme a la normativa de protección de datos personales vigente.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="footer">
              <div class="callToAcction">
                <input type="button" value="VOLVER" class="btn btn-volver-p2" (click)="gotoPaso(1, null)">
                <input type="button" value="GUARDAR" class="btn btn-continuar" (click)="onSubmit()">
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- PASO NUMERO 3 -->
    <div class="paso-3" *ngIf="pasos[0].P3.I">
      <div class="body">
        <app-solicitud-recibida
          [solicitud]="respuesta.NumAviso"
          [codigo]="respuesta.Mensajes.item[0].CodMensaje"
          [mensaje]="respuesta.Mensajes.item[0].TxtMensajes"
          [plazo]="plazo"
          [nCliente]="formData.value.nCliente"
          [nAviso]="respuesta.NumAviso">
        </app-solicitud-recibida>
      </div>
    </div>
  </div>
</div>

<!-- Modales -->
<div class="modal-suscripcion">
  <div class="punto-informacion">
    <ul>
      <li>
        <div class="contenido-terminos">
          <h3>Condiciones de uso.</h3>
          <p>
            Autorizo a la empresa Metrogas, RUT 96.722.460-K, para que me envíe los documentos tributarios electrónicos a través del correo electrónico registrado.
          </p>
          <p>
            La presente autorización estará vigente desde ahora y hasta el momento en que sea revocada por mí, en cualquier tiempo y sin necesidad de expresión de causa.
          </p>
          <div class="callToAcction">
            <input type="button" value="Cerrar" class="btn-cerrar-modal center" onclick="$('.basicLightbox').hide();">
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
<div class="modal-campos-requeridos">
  <div class="punto-informacion">
    <h3>Debes completar todos los datos solicitados para continuar</h3>
    <div class="campos-faltantes">
      <p id="lista-campos-faltantes"></p>
    </div>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
  </div>
</div>
<div class="modal-requerido">
  <div class="punto-informacion">
    <h3>Debes completar todos los datos solicitados para continuar</h3>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
  </div>
</div>

<div class="modal-solicitud-ingresada">
  <div class="punto-informacion">
    <h3 style="color: #004571;">Tu solicitud fue recibida</h3>
    <p style="margin: 10px 0 5px 0;">
      Tu solicitud <strong>fue ingresada correctamente</strong> en nuestro sistema.
    </p>
    <p style="color: #cc0000; font-weight: bold; margin: 10px 0;">
      ⚠️ Por favor, <u>NO vuelvas a enviar el formulario</u>. Tu reclamo ya está registrado.
    </p>
    <p style="font-size: 0.9em; color: #555; margin-top: 10px;">
      La confirmación con número de aviso está tardando más de lo esperado.
    </p>
    <div id="modal-solicitud-ref-container" style="background-color: #f0f4ff; border: 1px solid #004571; border-radius: 6px; padding: 12px; margin: 12px 0; text-align: center;">
      <p style="margin: 0 0 5px 0; font-size: 0.85em; color: #555;">Número de referencia de tu solicitud:</p>
      <strong style="color: #004571; font-size: 1.1em;" id="modal-solicitud-id-transaccion">—</strong>
      <p style="margin: 6px 0 0 0; font-size: 0.8em; color: #777;">Guarda este número para consultar el estado de tu solicitud.</p>
    </div>
    <p style="font-size: 0.85em; color: #555; margin-top: 6px;">
      Puedes consultar el estado ingresando a la sección de <a href="/tracking" style="color: #ff6600;">seguimiento</a>.
    </p>
    <div class="callToAcction">
      <input type="button" value="IR AL INICIO" class="btn btn-continuar center" onclick="$('.basicLightbox').hide(); window.location.href='/home';">
    </div>
  </div>
</div>

<div class="modal-error">
  <div class="punto-informacion">
    <h3>Ha ocurrido un error, vuelva a intentarlo más tarde</h3>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
  </div>
</div>

<div class="modal-error-cliente">
  <div class="punto-informacion">
    <h3>El número de cliente no existe o es erróneo</h3>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
  </div>
</div>

<div class="modal-numero-cliente">
  <div class="punto-informacion">
    <img class='img-numero-cliente' src='./assets/img/conoce-numero-cliente.jpg' alt="Conoce tu número de cliente">
    <br>
    <p class="texto-numero-cliente">
      Si no tienes tu número de cliente obtenlo ingresando tu dirección en metrogas.cl
    </p>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
    <br>
  </div>
</div>

<ngx-spinner>
  <p style="font-size: 20px; color: white">{{spinnerMsg}}</p>
</ngx-spinner>
